import React, { Component } from 'react';
import { NavigationButton, NavigationButtonGroup } from 'web-ui-components/lib/navigation/buttons';
import { ExitButton } from './Submit/ExitButton';
import { ExitModal } from './Submit/ExitModal';
import { content } from '../infrastructure/content/selectors';
import { CASE_ID } from '../utils/constants';
import { redirectToExit } from '../store/dataCapture/actions';
import { selectors as configSelectors } from '../infrastructure/config';
import { selectors as caseSelectors } from '../infrastructure/cases';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { redirectToBDDReviewScreen } from '../store/dataCapture/actions';
import { NAVIGATION_BACK, APPLICANT_FLOW } from '../utils/constants';
import { getQueryStringValueByName } from '../utils';

class Submit extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isExitModalOpen: false
    };
    this.toggleExitModal = this.toggleExitModal.bind(this);
  }

  toggleExitModal() {
    this.setState({
      ...this.state,
      isExitModalOpen: !this.state.isExitModalOpen
    });
  }

  render() {
    const { isExitModalOpen } = this.state;
    const {
      hideExit = false,
      exitButtonText,
      saveEnabled,
      handleExit,
      username,
      onClick,
      externalContent,
      redirectToBDDReviewScreen
    } = this.props;

    return (
      <div>
        <NavigationButtonGroup
          secondaryButtons={
            <NavigationButton.Secondary
              labelText={externalContent.headerBackButtonTitle}
              onClick={() => {
                redirectToBDDReviewScreen(
                  NAVIGATION_BACK,
                  getQueryStringValueByName(APPLICANT_FLOW)
                );
              }}
            />
          }
          tertiaryButtons={
            !hideExit &&
            ExitButton({
              onClick: this.toggleExitModal,
              saveEnabled,
              exitButtonText
            })
          }
          primaryButton={
            <NavigationButton.Primary
              labelText={externalContent.saveAndContinue}
              onClick={onClick}
            />
          }
        />

        {!hideExit &&
          ExitModal({
            toggleModal: this.toggleExitModal,
            handleExit,
            saveEnabled,
            username,
            isExitModalOpen
          })}
      </div>
    );
  }
}

const actionCreators = {
  handleExit: redirectToExit,
  redirectToBDDReviewScreen
};

const mapStateToProps = state => ({
  saveEnabled: !!configSelectors.getSingleEntry(state, CASE_ID),
  username: caseSelectors.getUsername(state),
  location: state.router.location,
  externalContent: content(state),
  state: state
});

const mapDispatchToProps = dispatch => bindActionCreators(actionCreators, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(Submit);
